import { FC, useEffect, useState } from 'react';
import { Tooltip } from 'react-tooltip';
import { Loader } from '@shared/uikit/loader';
import { IMainIndicatorsFilter } from 'pages/Main/components/Filter';
import LeftClientListPopup from 'pages/Main/components/LeftHashRate/ClientListPopup';
import LeftClientAccountListPopup from 'pages/Main/components/LeftHashRate/ClientAccountListPopup';
import Shield from '@shared/uikit/shield';
import { Link, useNavigate } from 'react-router-dom';
import PercentageMonitor from '@shared/uikit/percentage-monitor';
import { useBoeingLeftAccounts } from '@app/queries/boeing/useBoeingLeftAccounts';
import { IHostingIndicatorsFilter } from '@pages/Hosting/filter';
import { IClientsIndicator } from '@entities/hosting/IClientsIndicator';

interface IProps {
  data?: IClientsIndicator;
  loading: boolean;
}

export const ClientsIndicator: FC<IProps> = ({ data, loading = false }) => {
  return (
    <>
      <div className="p-[20px] border solid rounded-[16px] border-[#959595] border-opacity-30 w-full cursor-pointer">
        <div className="text-[#777777] flex justify-between items-center  mb-[10px]">
          Кол-во клиентов
        </div>

        {!loading && data ? (
          <div className="flex justify-between">
            <div>
              <div className="flex items-center gap-[4px]">
                <div className="text-[28px]">
                  {data.common !== null && data.common !== undefined ? data.common : '-'}
                </div>
                <div className="text-[14px]">
                  <span
                    className={`${data.common_diff > 0 ? 'text-[#29A70F]' : 'text-[red]'} flex gap-[5px] items-center`}
                  >
                    {(data.common_diff > 0 ? '+' : '') + data.common_diff}
                  </span>
                </div>
              </div>
              <div className="text-[10px] text-white rounded-[8px] px-[10px] bg-[#211F24] text-center">
                Общее
              </div>
            </div>
            <div>
              <div className="flex items-center gap-[4px]">
                <div className="text-[28px]">
                  {data.retail !== null && data.retail !== undefined ? data.retail : '-'}
                </div>
                <div className="text-[14px]">
                  <span
                    className={`${data.retail_diff > 0 ? 'text-[#29A70F]' : 'text-[red]'} flex gap-[5px] items-center`}
                  >
                    {(data.retail_diff > 0 ? '+' : '') + data.retail_diff}
                  </span>
                </div>
              </div>
              <div className="text-[10px] text-white rounded-[8px] px-[10px] bg-[#211F24] text-center">
                Розница
              </div>
            </div>
            <div>
              <div className="flex items-center gap-[4px]">
                <div className="text-[28px]">
                  {data.wholesale !== null && data.wholesale !== undefined ? data.wholesale : '-'}
                </div>
                <div className="text-[14px]">
                  <span
                    className={`${data.wholesale_diff > 0 ? 'text-[#29A70F]' : 'text-[red]'} flex gap-[5px] items-center`}
                  >
                    {(data.wholesale_diff > 0 ? '+' : '') + data.wholesale_diff}
                  </span>
                </div>
              </div>
              <div className="text-[10px] text-white rounded-[8px] px-[10px] bg-[#211F24] text-center">
                Опт
              </div>
            </div>
          </div>
        ) : (
          <Loader size={45} loading={true} padding="9px" />
        )}
      </div>
    </>
  );
};
